/**
 * A utility function that provides natural sorting for strings*
 *
 * @param a First string to compare
 * @param b Second string to compare
 * @param direction Sort direction: 1 for ascending, -1 for descending
 * @returns A number indicating the sorting order
 */
export const naturalSort = (
  a: string,
  b: string,
  direction: 1 | -1
): number => {
  // Extract chunks of numbers and text
  const aParts = String(a || '')
    .split(/(\d+)/)
    .filter(Boolean);
  const bParts = String(b || '')
    .split(/(\d+)/)
    .filter(Boolean);

  const minLength = Math.min(aParts.length, bParts.length);

  for (let i = 0; i < minLength; i++) {
    const aIsNumber = !isNaN(Number(aParts[i]));
    const bIsNumber = !isNaN(Number(bParts[i]));

    // If both are numbers, compare as numbers
    if (aIsNumber && bIsNumber) {
      const diff = parseInt(aParts[i], 10) - parseInt(bParts[i], 10);
      if (diff !== 0) return diff * direction;
    }
    // If only one is a number, numbers sort before strings
    else if (aIsNumber) return -1 * direction;
    else if (bIsNumber) return 1 * direction;
    // If both are strings, compare as strings
    else {
      const diff = aParts[i].localeCompare(bParts[i]);
      if (diff !== 0) return diff * direction;
    }
  }

  // If all compared parts are equal, the shorter one comes first
  return (aParts.length - bParts.length) * direction;
};
